import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// components
import {CardBorder} from '../CardBorder';
import {Divider} from '@mui/joy';

// styles
import {
  CardPaymentWrapper,
  CardPaymentTop,
  CardPaymentTopLeft,
  CardPaymentBottom,
  CardPaymentBottomLeft,
  CardPaymentBottomLeftItem,
  DeferButton,
} from './CardPayment-styles';
import {
  Subtitle,
  TextColors,
  TextSmall,
  TextExtraSmall,
  TextDefault,
} from '../../styles';

// types
import {SubscriptionPayment} from '../../services/ApiService/types';

type Props = {
  payment: SubscriptionPayment;
  onDeferPaymentClick: (
    e: React.MouseEvent,
    payment: SubscriptionPayment,
  ) => void;
};

const CardPaymentSubscription = ({payment, onDeferPaymentClick}: Props) => {
  const {t} = useTranslation();

  return (
    <CardBorder variant="grey">
      <CardPaymentWrapper>
        <CardPaymentTop>
          <CardPaymentTopLeft>
            <Subtitle
              bold="bold"
              color={TextColors.brand}>{`#${payment.paymentNumber}`}</Subtitle>
            <TextSmall bold="bold">{payment.status}</TextSmall>
          </CardPaymentTopLeft>
          <TextExtraSmall bold="bold">{payment.paymentDate}</TextExtraSmall>
        </CardPaymentTop>
        <Divider />
        <CardPaymentBottom>
          <CardPaymentBottomLeft>
            <CardPaymentBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('subscription_payment_paymentAmount')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(payment.paymentTotal)}
              </TextDefault>
            </CardPaymentBottomLeftItem>
            <CardPaymentBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('subscription_payment_balanceWithTax')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(payment.balanceWithTax)}
              </TextDefault>
            </CardPaymentBottomLeftItem>
          </CardPaymentBottomLeft>
          {payment.canBeDeferred && (
            <DeferButton
              variant="outlined"
              onClick={(e) => onDeferPaymentClick(e, payment)}>
              {t('payment_defer')}
            </DeferButton>
          )}
        </CardPaymentBottom>
      </CardPaymentWrapper>
    </CardBorder>
  );
};

export default CardPaymentSubscription;
